module.exports = __webpack_public_path__ + "static/img/loader-green-clear.83b1528.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loader-green-clear.gif
// module id = Vlwu
// module chunks = 1